import { render } from "./PermissionsPage.vue?vue&type=template&id=567a1d2e&scoped=true"
import script from "./PermissionsPage.vue?vue&type=script&lang=js"
export * from "./PermissionsPage.vue?vue&type=script&lang=js"

import "./PermissionsPage.vue?vue&type=style&index=0&id=567a1d2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567a1d2e"]])

export default __exports__